// Load the pinned motion assets when the landing stage or its card band enters view.
(() => {
  'use strict';
  const script = document.currentScript;
  const stage = document.querySelector('[data-dwm-stage]');
  const shop = document.querySelector('.dws');
  if (!stage) return;

  let started = false;
  let observer;
  const load = () => {
    if (started) return;
    started = true;
    observer?.disconnect();
    const next = document.createElement('script');
    next.src = script.dataset.motionSrc;
    next.async = false;
    if (window.gsap) { document.head.appendChild(next); return; }
    const gsap = document.createElement('script');
    gsap.src = script.dataset.gsapSrc;
    gsap.async = false;
    document.head.appendChild(gsap);
    document.head.appendChild(next); // Ordered execution; motion waits until document parsing finishes.
  };

  if (!('IntersectionObserver' in window) || window.Shopify?.designMode || stage.closest('.dwm--capture')) {
    load();
    return;
  }
  // The usual top entry needs the same early parallel fetch as the original deferred tags.
  if (stage.getBoundingClientRect().top < innerHeight && stage.getBoundingClientRect().bottom > 0) {
    load();
    return;
  }
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) load();
    else if (!started && stage.getBoundingClientRect().bottom <= 0) stage.closest('[data-dwm]').dataset.dwmDeepEntry = 'true';
  });
  observer.observe(stage);
  if (shop) observer.observe(shop);
  else document.addEventListener('DOMContentLoaded', () => {
    const band = document.querySelector('.dws');
    if (!started && band) observer.observe(band);
  }, { once: true });
})();
